export default "__VITE_ASSET__Msg57USEadASvSStYSdmzA__";